import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { User } from 'src/app/models/user';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ReportService } from '../../services/report/report.service';
import { FunctionsService } from 'src/app/modules/shared/services/functions.service';
import { statusUrl } from 'src/app/modules/shared/common/api';
import { Router } from '@angular/router';

@Component({
  selector: 'app-department-summary',
  templateUrl: './department-summary.component.html',
  styleUrls: ['./department-summary.component.scss']
})
export class DepartmentSummaryComponent implements OnInit {

  keyWords = [];
  menuList = [
    {
      label:"Display",
      name:"status",
      type:"select",
      value: ["No. of Transactions","Amount"]
    }
  ];
  
  pipe = new DatePipe('en-US');

  isNoResult: boolean = false;
  loading:boolean = false;
  isKeyWord:boolean = false;
  isRole:boolean = false;
  keyTable = '';
  queryString = '';

  totalRec : number;
  page: number = 1;
  fromDate = 0;
  toDate = 0;
  perPage: number;
  user = new User('');
  listReport:any;
  stat: string;

  travel: any;
  dialogConfig:any;
  formGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public reportService: ReportService,
    public functionService: FunctionsService,
    private router: Router
  ) {
    this.isRole = this.user.getRole();
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      filter:['',null],
      status: ['',null],
      from: ['',null],
      to: ['',null]
    });
    this.getList();

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';
    this.dialogConfig.backdropClass = 'mat-dialog-backdrop';
  }

  getFilter() {
    this.page = 1;
    this.isKeyWord = true;
    if (this.isKeyWord) {
      this.keyTable = 'table-chiplist';
    }

    if(this.formGroup.controls['from'].value !== '' && this.formGroup.controls['from'].value !== null){
      this.formGroup.controls['from'].setValue(this.pipe.transform(this.formGroup.controls['from'].value, 'yyyy-MM-dd'));
    }

    if(this.formGroup.controls['to'].value !== '' && this.formGroup.controls['to'].value !== null){
      this.formGroup.controls['to'].setValue(this.pipe.transform(this.formGroup.controls['to'].value, 'yyyy-MM-dd'));
    }

    this.getList();
    this.keyWords = this.functionService.filter(this.formGroup,this.keyWords);
  }

  getList() {
    let param = [];

    if (this.page) {
      param.push('page='+this.page);
    }  

    if(this.formGroup.controls['from'].value !== null){
      param.push('from='+this.formGroup.controls['from'].value);
    }

    if(this.formGroup.controls['to'].value !== null){
      param.push('to='+this.formGroup.controls['to'].value);
    }

    if(this.formGroup.controls['status'].value !== null){
      this.stat = this.formGroup.controls['status'].value;
      if (this.stat !== 'amount' && this.stat != '') {
        this.stat =  'count';
      }
      param.push('filter='+this.formGroup.controls['status'].value);
    }

    if (param.length) {
      this.queryString = '?' + param.join('&');
    }

    this.loading = false;
    this.isNoResult = false;
    this.reportService.url = statusUrl+'/department'+ this.queryString;
    this.reportService.getFilter().subscribe(res=>{
      this.totalRec = res.total;
      this.perPage = res.per_page;
      this.listReport = res.data;
      this.loading = false;
      if (res.total == 0) {
        this.isNoResult = true;
      }
    });
  }

  onClearForm() {
    this.formGroup.reset();
    this.keyWords = [];
    this.getList();
    this.isKeyWord  = false;
    this.keyTable = '';
  }

  openDetail(res) {
    this.dialogConfig.data = {res};
    this.dialogConfig.width = '100vw';
    let dialogRef = this.dialog.open(null, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getList();
      }
    });
  }

  createDialog(res) {
    this.dialogConfig.width = '100vw';
    let dialogRef = this.dialog.open(null, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getList();
      }
    });
  }

  pageChange(newPage: number) {
    this.page = newPage;
    this.getList();
		return false;
  }
  
  removeKeywords(key){
    this.formGroup.controls[key].setValue('');
    this.functionService.removeFilter(this.keyWords,key);
    this.getList();
    this.keyTable = '';
  }

  onChangeStartDate(e) {
    this.fromDate = e.value;
  }

  onChangeEndDate(e) {
    this.toDate = e.value;
  }

  keypressValidateNumber(e) {
    return false;
  }  

  download() {
    this.reportService.downloadPDF(statusUrl + '/department/export' + this.queryString).subscribe(res => {
      if(res) {
        this.loading = false;
        const a = document.createElement('a');
        a.href = URL.createObjectURL(res);
        a.download = this.functionService.getDate()+'-per-department.xlsx';
        document.body.appendChild(a);
        a.click();
      }
    });
  }

 /**
   * 
   * @param name filter by name
   * @param status filter by status approved/pending approved
   * @param type 
   */
  detailReport(name){
    this.router.navigate(['/travel-cash-approver'], { queryParams: { department:name} });
  }
s
}
